import React, { useState } from "react";
import { actionGetRptPtosPanorama } from "../../../features/relatorios/rptPtsPanorama/slices";
import factoryFields from "../../../helpers/factory-fields";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import Button from "../../Button";
import Select from "../../Select";

const RptPtosPanorama = () => {
  const [state, setState] = useState("");
  const dispatch = useAppDispatch();
  const { getRptPtosPanorama } = useAppSelector((state) => state);

  const [value, setValue] = useState("");

  const handlerChange = (e: any) => {
    setValue(e.target.value);
    setState(e.target.value);
  };

  const handlerReportPanorama = () => {
    dispatch(actionGetRptPtosPanorama(state));
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-4">
          <div className="mb-20">
            <Select
              size="sm"
              label="Formato do arquivo"
              value={value}
              options={factoryFields.typesReport}
              onChange={handlerChange}
            />
          </div>
          <Button size="sm" onClick={handlerReportPanorama} loading={getRptPtosPanorama.status === "loading"}>
            Baixar relatório
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RptPtosPanorama